<footer class="sticky-footer">
    <div class="container my-auto">
        <div class="footer-meta my-auto">
            <span>Copyright © SZZ 2025-{{ currentYear }}</span>
            <span class="footer-version">Verzija {{ appVersion }}</span>
        </div>
    </div>
</footer>
